// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2209":"8eb47d0f","3805":"2ea4fdec","5597":"2ea4fdec","6811":"be7a87fd","8264":"0dfe2d4f","8573":"de9c9365"}[chunkId] + ".chunk.css";
};